
import { use, registerTheme } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { UniversalTransition } from 'echarts/features'
import { BarChart } from 'echarts/charts'
import {
  TitleComponent,
  DatasetComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent
} from 'echarts/components'

import VChart from 'vue-echarts'
import { exportCanvasAsPng } from '@/utils/enerEchartsFunctions'

// custom theme
import themeEnerdata from '@/assets/json/echarts_themes/enerdata.project.json'

use([
  CanvasRenderer,
  UniversalTransition,
  BarChart,
  TitleComponent,
  DatasetComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent
])

// registering custom theme
registerTheme('enerdata-theme', themeEnerdata.theme)

export default {
  name: 'EnerEchartsBar',
  components: {
    VChart
  },
  props: {
    download: {
      type: Boolean,
      default: false
    },
    title: {
      required: false,
      type: String,
      default: ''
    },
    filename: {
      required: false,
      type: String,
      default: ''
    },
    option: {
      type: Object,
      default () {
        return {}
      }
    },
    initOptions: {
      type: Object,
      default () {
        return {}
      }
    },
    updateOptions: {
      type: Object,
      default () {
        return {}
      }
    },
    group: {
      type: String,
      default: null,
      required: false
    }
  },
  data () {
    return {}
  },
  watch: {
    download: {
      async handler () {
        if (this.download === true) {
          const canvas = this.$refs.chart.getDom().getElementsByTagName('canvas')[0]
          await exportCanvasAsPng(canvas, this.filename, this.title)
          this.$emit('exporting')
        }
      }
    }
  }
}
